export default __webpack_public_path__ + "static/media/KanamiNakabayashiCV2020.8666a8ae.pdf";